import { render, staticRenderFns } from "./Creatives.vue?vue&type=template&id=20988122"
import script from "./Creatives.vue?vue&type=script&lang=js"
export * from "./Creatives.vue?vue&type=script&lang=js"
import style0 from "./Creatives.vue?vue&type=style&index=0&id=20988122&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports